import ko from 'knockout'
import template from './index.html'

function initialize (params) {
  this.title = params.title
  this.vm = params.vm
  this.label = params.label
  this.labelStyle = params.labelStyle
  this.style = params.style
  // 是否开启折叠 true 展开  false 折叠  undefined 不开启   折叠不能与自定义标题一起使用
  this.expand = ko.observable(params.expand)
  // 根据expand判断图标内容
  this.expandValue = ko.computed(() => {
    return this.expand() ? '-' : '+'
  })
  // 不影响原来title样式
  this.leftBorderStyle = this.expand() !== undefined ? {
    borderLeft: 'none'
  } : ''
  this.animated = params.animated || ko.observable(false)
  // 外界动态改变动画效果
  this.classes = ko.computed(() => {
    if (this.animated && this.animated.subscribe) {
      return this.animated() ? 'slideInUp animated' : ''
    } else {
      return this.animated ? 'slideInUp animated' : ''
    }
  })
  this.showContent = ko.computed(() => {
    return this.expand() === undefined ? true : this.expand()
  })
  // 控制展开收起
  this.expandClick = function () {
    this.expand(!this.expand())
  }
}
export default {
  name: 'boxcontent',
  init: initialize,
  template
}



// WEBPACK FOOTER //
// ./src/components/boxcontent/index.js